import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'projects/chat-common/src/lib/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'chatapp';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const accessCode = this.route.snapshot.queryParamMap.get('accessCode');
    if (accessCode) {
      this.authService.signWithRefreshToken(accessCode).subscribe({
        next: () => {
          // Remove accessCode from URL and navigate to protected area
          this.router.navigate([], {
            queryParams: { accessCode: null },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          }).then(() => {
            // Navigate to health-assistant after successful auth
            this.router.navigate(['/health-assistant']);
          });
        },
        error: (err) => {
          console.error('Authorization with accessCode failed', err);
        }
      });
    }
  }
}
